module.exports = __webpack_public_path__ + "static/media/sendIcon.c988b183.PNG";